import { render } from "./BistroLogo.vue?vue&type=template&id=44ade2ce&scoped=true"
import script from "./BistroLogo.vue?vue&type=script&lang=js"
export * from "./BistroLogo.vue?vue&type=script&lang=js"

import "./BistroLogo.vue?vue&type=style&index=0&id=44ade2ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ade2ce"]])

export default __exports__